import React, { forwardRef, useRef } from 'react';
import { mainBarPropTypes } from './MainBarPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Hamburger from './components/Hamburger/Hamburger';
import Nav from './components/Nav/Nav';
import Logo from './components/Logo/Logo';
import SearchBar from './components/SearchBar/SearchBar';
import HeaderItemsCollection from './components/HeaderItemsCollection/HeaderItemsCollection';
import SearchResults from './components/SearchResults/SearchResults';
import * as styles from './MainBar.module.scss';
const MainBar = /*#__PURE__*/forwardRef(({
  nav,
  logo,
  searchBar,
  headerItemsCollection,
  onChange,
  isMobileOpen,
  handleOpenMobile,
  setIsSearching,
  isSearching,
  searchResults,
  searchTerm,
  sendSearchData,
  headerRef
}, ref) => {
  if (!nav && !logo && !searchBar && !headerItemsCollection) {
    return null;
  }
  const searchBarRef = useRef();
  const expandAndFocusSearchBar = () => {
    var _searchBarRef$current;
    (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 ? void 0 : _searchBarRef$current.expandAndFocusSearchBar();
  };

  /**
   /* Prop objects with data, functions and states
   */
  const navProps = {
    ...nav,
    isMobileOpen,
    isSearching
  };
  const searchBarProps = {
    ...searchBar,
    onChange,
    isMobileOpen,
    handleOpenMobile,
    setIsSearching,
    isSearching
  };
  const hamburgerProps = {
    isMobileOpen,
    onClick: handleOpenMobile
  };
  const headerItemsCollectionProps = {
    items: headerItemsCollection,
    expandAndFocusSearchBar
  };
  const searchResultsProps = {
    searchResults,
    isSearching,
    setIsSearching,
    searchTerm,
    sendSearchData
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${isSearching ? styles.rootSearching : ''}`,
    ref: ref
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement(Hamburger, Object.assign({}, hamburgerProps, {
    classname: styles.rootHamburger
  })), /*#__PURE__*/React.createElement(Nav, navProps), /*#__PURE__*/React.createElement(Logo, Object.assign({}, logo, {
    classname: styles.rootLogo
  })), /*#__PURE__*/React.createElement(SearchBar, Object.assign({}, searchBarProps, {
    ref: searchBarRef,
    headerRef: headerRef,
    classname: styles.rootSearchBar
  })), /*#__PURE__*/React.createElement(HeaderItemsCollection, headerItemsCollectionProps))), searchResults && /*#__PURE__*/React.createElement(SearchResults, searchResultsProps));
});
MainBar.displayName = 'MainBar';
export default MainBar;